import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Zastępuje useNavigate
import { useTranslation } from 'react-i18next'; // Zastępuje falcon-i18n
import PropTypes from 'prop-types';
import AddProductInput from '../../UI/AddProductInput/AddProductInput';
import AddToCartButton from '../AddToCartButton/AddToCartButton';
import BaseComponent from './BaseComponent';
import { useUserContext } from '../../../context/UserContext';
import './ProductSidebarAddSimpleProduct.scss';

const ProductSidebarAddSimpleProduct = ({ product: { sku = null, ...rest } }) => {
    const kitchenVendorIds = ['601586', '3613', '27293', '16922', '183812', '027293'];
    const [baseComponentActive, setBaseComponentActive] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { user } = useUserContext();
    const { is_on_order_only, is_saleable, days_to_delivery, name, vendor_id, advanced_product_inventory, uid } = rest;

    // Ustawienie początkowej ilości z zabezpieczeniem
    const initialQuantity = advanced_product_inventory?.min_sale_qty || 1;
    const [quantity, setQuantity] = useState(initialQuantity);

    useEffect(() => {
        setQuantity(initialQuantity);
    }, [advanced_product_inventory?.min_sale_qty]);

    const closeBaseComponent = () => setBaseComponentActive(false);

    const subscribeToAlert = (uid) => {
        try {
            const encodedUID = atob(uid); // Zabezpieczenie przed błędami Base64
            const redirectPath = `/productalert/add/${encodedUID}${window.location.pathname}`;
            if (!user) {
                navigate(`/customer/login?referrer=${redirectPath}`);
                return;
            }
            navigate(redirectPath);
        } catch (error) {
            console.error('Błąd dekodowania UID:', error);
        }
    };

    // Produkt tylko w sklepie
    if (is_on_order_only && days_to_delivery === 0) {
        return (
            <>
                {kitchenVendorIds.includes(String(vendor_id)) && (
                    <p className="base-component-text">
                        {t('product.baseComponentText')}{' '}
                        <span
                            onClick={() => setBaseComponentActive(true)}
                            className="base-component-text-pink"
                        >
              {t('product.baseComponentTextPink')}
            </span>
                    </p>
                )}
                <div className="sidebar-add-product">
                    <button className="sidebar-add-product__unavailable" disabled>
                        {t('product.onlyInStore')}
                    </button>
                </div>
                {baseComponentActive && (
                    <BaseComponent closeComponent={closeBaseComponent} vendor_id={String(vendor_id)} />
                )}
            </>
        );
    }

    // Produkt niedostępny w sprzedaży online
    if (!is_saleable) {
        return (
            <div className="sidebar-add-product unavailable">
                <button className="sidebar-add-product__unavailableWeb" disabled>
                    {t('product.notWebshop')}
                </button>
                <div className="sidebar-alert">
                    <a className="sidebar-alert__text" onClick={() => subscribeToAlert(uid)}>
                        {t('product.notice')}
                    </a>
                </div>
            </div>
        );
    }

    // Produkt dostępny do sprzedaży
    return (
        <>
            {advanced_product_inventory && advanced_product_inventory.enable_qty_increments === '0' && (
                <div className="sidebar-add-product">
                    <AddProductInput
                        minSaleQty={advanced_product_inventory.min_sale_qty}
                        quantity={quantity}
                        setQuantity={setQuantity}
                        advancedInventory={advanced_product_inventory}
                    />
                    <div className="sidebar-add-product__submit">
                        <AddToCartButton sku={sku} quantity={quantity} name={name} product={rest} />
                    </div>
                </div>
            )}
            {advanced_product_inventory && advanced_product_inventory.enable_qty_increments === '1' && (
                <div className="sidebar-add-product-decimal-quantity">
                    <AddProductInput
                        minSaleQty={advanced_product_inventory.min_sale_qty}
                        quantity={quantity}
                        setQuantity={setQuantity}
                        advancedInventory={advanced_product_inventory}
                        prices={rest.prices}
                    />
                    <div className="sidebar-add-product-decimal-quantity__submitDecimalQuantity">
                        <AddToCartButton sku={sku} quantity={quantity} name={name} product={rest} />
                    </div>
                </div>
            )}
        </>
    );
};

ProductSidebarAddSimpleProduct.propTypes = {
    product: PropTypes.object,
};

export default ProductSidebarAddSimpleProduct;